export default __webpack_public_path__ + "static/media/Parent_Illustrations-09.727a8f29.svg";